import { Label as HeadlessLabel, LabelProps } from "@headlessui/react";
export const labelClasses = "block font-medium text-sm text-gray-700";
export default function Label({
    children,
    className,
    ...rest
}: LabelProps & { htmlFor?: never }) {
    return (
        <HeadlessLabel className={`${labelClasses} ${className}`} {...rest}>
            {children}
        </HeadlessLabel>
    );
}
